"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledcomponents = require('styled-components');

var i = _styledcomponents.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    outline: 4px solid ", ";\n"])), function (_ref) {
  var o = _ref.theme;
  return o.color.keyboardFocus;
}),
    l = exports.b = _styledcomponents.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    outline: 4px solid ", ";\n"])), function (_ref2) {
  var o = _ref2.theme;
  return o.color.keyboardFocusInverse;
});

exports.a = i;
exports.b = l;